<template>
  <div class="row p-0 m-0 mt-2">
    <div class="col-2">
      <font-awesome-icon :icon="notification.icon.icon" :class="notification.icon.colour" size="3x"></font-awesome-icon>
    </div>
    <div class="col">
      <a href="#" class="float-right" @click.prevent="removeNotification(notification)">
        <font-awesome-icon icon="times" class="text-red"></font-awesome-icon>
      </a>
      <span class="bold text-blue">{{ notification.subject }}</span>
      <br>
      <span>
        <b>{{ notification.message }}</b>&nbsp;
      </span>
      <br>
      <span>
          <small>
            {{ notification.created_at_formatted  }}
          </small>
        </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SingleNotification',
  props: ['notification'],
  methods: {
    removeNotification (notification) {
      this.axios.put('/notifications/' + notification.id + '/read', {}, 'PUT').then(() => {
        this.$emit('removed', notification)
      })
    }
  }
};
</script>
